import { NgModule } from '@angular/core';
import { LibLoanIconComponent } from './lib-loan-icon.component';

@NgModule({
  declarations: [LibLoanIconComponent],
  imports: [],
  exports: [LibLoanIconComponent],
})
export class LibLoanIconModule {}
